import { Api, ModelRow } from "@mcleod/core";
import { AutogenLayoutRatewareTariffCodeMaintenance } from "./autogen/AutogenLayoutRatewareTariffCodeMaintenance";
import { ClickEvent, DataHeader, DataSourceMode, DataSourceModeChangeEvent, DropdownItem, DropdownSelectionEvent, Layout, LookupModelSearchEvent, LookupModelSelectionEvent, SaveButton, SlideoutDecorator } from "@mcleod/components";
import { RatewareCalcUomCode } from "./RatewareCalcUomCode";
import { CommonDialogs } from "@mcleod/common";

export class RatewareTariffCodeMaintenance extends AutogenLayoutRatewareTariffCodeMaintenance {

    private ratewareCalcUomCodeLayout = Layout.getLayout("lme/powerbroker/ltl/RatewareCalcUomCode") as RatewareCalcUomCode;

    public override doAfterDataHeaderSetup(dataHeader: DataHeader): void {
        dataHeader.promptToSaveChanges();
    }

    textboxTliCalcUomCodeBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.mode = this.mainDataSource.mode;
    }

    textboxTariffSelectionAfterDropdownSelection(event: ClickEvent) {
        const selectedItem = this.textboxTariffSelection.selectedItem;
        const valueText = selectedItem.value;
        const values: string[] = valueText.split(" - ");
        this.sourceRatewareTariffCodeMasterfile.activeRow.set("rateware_tariff_name", values[0]);
        this.sourceRatewareTariffCodeMasterfile.activeRow.set("rateware_tariff_date", values[1]);
    }

    textboxTliCalcUomCodeOnLookupModelSelection(event: LookupModelSelectionEvent) {
        const fieldCodeDesc: string = event.selection.get("field_code_desc");
        if (this.sourceRatewareTariffCodeMasterfile.activeRow.isNull("rateware_product_info")) {
            this.sourceRatewareTariffCodeMasterfile.activeRow.set("rateware_product_info", fieldCodeDesc);
        }
    }

    sourceRatewareTariffCodeMasterfileAfterModeChange(event: DataSourceModeChangeEvent) {
        Api.search("lme/powerbroker/rateware-tariff-code").then((response) => {
            if (response.data.length > 0) {
                const dropdownItems: DropdownItem[] = [];
                response.data.forEach((row) => {
                    if (this.sourceRatewareTariffCodeMasterfile.mode == DataSourceMode.SEARCH || row.rtc_uid == 0) {
                        const combinedName = row.rateware_tariff_name + " - " + row.rateware_tariff_date;
                        const item: DropdownItem = new DropdownItem(combinedName, combinedName);
                        dropdownItems.push(item);
                    }
                });
                if (dropdownItems.length == 0)
                    this.textboxTariffSelection.tooltip = "No Rateware Tariff Codes available.";
                this.textboxTariffSelection.items = dropdownItems;
            }
        });
        if (event.newMode === DataSourceMode.SEARCH) {
            this.textboxTariffSelection.visible = true;
            this.buttonAddChargeType.visible = false;
        } else if (event.newMode === DataSourceMode.UPDATE) {
            this.textboxTliCalcUomCode.enabled = false;
            this.textboxTariffSelection.visible = false;
            this.buttonAddChargeType.visible = false;
        } else if (event.newMode != DataSourceMode.NONE) {
            this.textboxTariffSelection.visible = true;
            this.buttonAddChargeType.visible = true;
        }
    }

    private addSaveAndCloseButton: SaveButton = SaveButton.create({
        id: "saveAndCloseButton",
        caption: "Save & Close",
        rowBreak: false,
        onClick: (event: ClickEvent) => {
            if (this.ratewareCalcUomCodeLayout.fieldCodeStartsWithRW() === false) {
                CommonDialogs.showError("Code must start with 'RW_' and be at least 4 characters long.");
                return;
            }
            this.ratewareCalcUomCodeLayout.sourceRatewareCalcUomCode.post().then((row) => {
                this.ratewareCalcUomCodeLayout.slideOut();
                this.activeRow.setLookupModelData("field_code", new ModelRow("lme/powerbroker/rateware-tariff_code", false,
                    { field_code: this.activeRow.get("field_code") }));
            })
        }
    })

    buttonAddChargeTypeOnClick(event: ClickEvent) {
        this.ratewareCalcUomCodeLayout = Layout.getLayout("lme/powerbroker/ltl/RatewareCalcUomCode") as RatewareCalcUomCode;
        const title = "Add - Rateware Calc UOM Code";

        const slideoutDecorator = new SlideoutDecorator({
            title: title,
            layout: this.ratewareCalcUomCodeLayout,
            fillVerticalSpace: true,
            width: 1000,
            overlayProps: { greyedBackground: true },
            onClose: async (cancelled: boolean) => {
                const row: ModelRow = this.ratewareCalcUomCodeLayout.activeRow;
                if (!cancelled)
                    this.ratewareCalcUomCodeLayout.slideOut();
                if (this.ratewareCalcUomCodeLayout.sourceRatewareCalcUomCode.hasChanged(true)) {
                    const message = "Unsaved changes are present.  Do you wish to leave without saving changes?";
                    const dialogProps = {
                        yesButtonCaption: "Leave",
                        noButtonCaption: "Stay"
                    };
                    const leave = await CommonDialogs.showYesNo(message, "Leave Without Saving?", dialogProps);
                    if (leave !== true)
                        return;
                }
                this.ratewareCalcUomCodeLayout.slideOut();
            },
            addlComponents: this.addSaveAndCloseButton,
            doAfterSlideIn: () => {
                const rowArr: ModelRow[] = [];
                const modelRow: ModelRow = new ModelRow(this.ratewareCalcUomCodeLayout.sourceRatewareCalcUomCode.url, true,
                    {field_table_alias: "TAR", field_name: "calc_uom_code", field_code: "RW_"});
                rowArr.push(modelRow);
                this.ratewareCalcUomCodeLayout.sourceRatewareCalcUomCode.setRowsAndMode(DataSourceMode.NONE, rowArr);
                this.ratewareCalcUomCodeLayout.sourceRatewareCalcUomCode.displayDataInBoundComponents();
                this.ratewareCalcUomCodeLayout.textboxFieldCode.focus();
            }
        });
    }
}
